module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/passenger-manual-notif/passenger-manual-notif-add/passenger-manual-notif-add.component.css
// module id = ./src/app/components/passenger-manual-notif/passenger-manual-notif-add/passenger-manual-notif-add.component.css
// module chunks = main